:host(c-step) {
  /**
   * @prop --c-step-color: Step color
   * @prop --c-step-color-complete: Completed step color
   * @prop --c-step-text-color-complete: Completed step text color
   */
  --_c-step-color: var(--c-step-color, var(--c-tertiary-500));
  --_c-step-color-complete: var(--c-step-color-complete, var(--c-primary-600));
  --_c-step-text-color-complete: var(--c-step-text-color-complete, var(--c-white));

  position: relative;
  width: 180px;
}

:host(.mobile) {
  width: 22px;
  height: 22px;
}

:host(.mobile) .c-step__label {
  display: none;
}

.c-step {
  display: grid;
  justify-items: center;
  padding: 0;
  gap: 8px;
  position: relative;
  box-sizing: border-box;

  &__indicator {
    box-sizing: border-box;

    .dot {
      background-color: var(--c-white);
      box-shadow: inset 0 0 0 2px var(--_c-step-color);
      border-radius: 22px;
      height: 22px;
      width: 22px;
      position: relative;

      &.current {
        box-shadow: inset 0 0 0 3px var(--_c-step-color-complete);

        &::before {
          content: "";
          border-radius: 14px;
          height: 10px;
          width: 10px;
          background-color: var(--_c-step-color-complete);
          position: absolute;
          top: 6px;
          left: 6px;
        }
      }
    }

    .complete {
      background-color: var(--_c-step-color-complete);
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  &--complete {
    .c-step__indicator {
      > div {
        position: relative;
        border-radius: 22px;
        height: 22px;
        width: 22px;
        background-color: var(--_c-step-color-complete);
        padding: 4px;

        svg {
          position: relative;
          fill: var(--_c-step-text-color-complete);

          .path {
            fill: none;
            stroke: var(--_c-step-text-color-complete);
            stroke-dashoffset: 0;
            stroke-width: 13;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-miterlimit: 10;
          }
        }
      }
    }
  }
}
